import { Flex, BKJCheckboxListItem, BKJIcon } from '@bookjane2/bookjane-design-library';
import { defaultAgencyProfileImg } from 'assets';
import {
  AgencyGridCardWrapper,
  AgencyGridCardContentWrapper,
  AgencyGridAvatarWrapper,
  AgencyName,
  AgencyCount,
  AgencyLabel,
  AgencyLicenceNumber,
} from 'modals/ShiftModal/components/AgencyGridSelect/AgencyGridSelect.styled';
import { BKJRadioInput } from 'components/BKJRadioInput/BKJRadioInput';
import { FC } from 'react';
import { AgencyNode } from 'modals/ShiftModal/components/AgencyGridSelect/AgencyGridSelect.types';
import { AgencyCommunity, Community } from 'types/graphql';
import { useAgencyGridSelectPropsContext } from 'modals/ShiftModal/components/AgencyGridSelect/AgencyGridSelect.props.context';
import { useTranslation } from 'hooks/useTranslation';
import { FormatCurrency } from 'components/FormatCurrency';

export const AgencyGridSelectCardComponent: FC<{ agency: AgencyNode }> = ({ agency }) => {
  const { t } = useTranslation();
  const { selected, onChangeForm, type } = useAgencyGridSelectPropsContext();

  const isMarketplace = agency.sourceType === 'marketplace';
  const nameToUse = isMarketplace ? 'selectedMarketplaceCommunities' : 'selectedAgencies';

  const marketplaceAgency = isMarketplace
    ? (agency as Community & { sourceType: 'marketplace' })
    : null;
  const agencyCommunity = !isMarketplace
    ? (agency as AgencyCommunity & { sourceType: 'agency' })
    : null;

  const avatarUrl = isMarketplace
    ? marketplaceAgency?.avatarUrls?.origin
    : agencyCommunity?.agency?.avatarUrls?.origin;

  const licenseNumber = isMarketplace ? '' : agencyCommunity?.agency?.liability?.licenceNumber;

  const rate = isMarketplace
    ? marketplaceAgency?.communitiesPositions?.[0]?.chargeRate
    : agencyCommunity?.agencyPositionDetails?.[0]?.openRate;

  return (
    <AgencyGridCardWrapper key={agency.id}>
      <AgencyGridCardContentWrapper>
        <AgencyGridAvatarWrapper
          alt="AgencyProfilePic"
          src={!avatarUrl ? defaultAgencyProfileImg : (avatarUrl as unknown as string)}
        />
        <Flex flexDirection="column" padding="8px" gap="10px" height="100%">
          <Flex flexDirection="column" gap="3px">
            <AgencyName>{agency?.name}</AgencyName>
            {licenseNumber && <AgencyLicenceNumber>{licenseNumber}</AgencyLicenceNumber>}
            <AgencyCount>{`${agency.availableJanes.count} ${t(
              'common:AVAILABLE',
            ).toLowerCase()}`}</AgencyCount>
            {agency.averageRating.value && agency.averageRating.count > 0 && (
              <Flex gap="3px" alignItems="center" alignContent="center">
                <BKJIcon iconName="Star" />
                <AgencyLabel>{`${agency.averageRating.value}`}</AgencyLabel>
                <AgencyCount>{`(${agency.averageRating.count})`}</AgencyCount>
              </Flex>
            )}
          </Flex>

          {rate && (
            <AgencyLabel>
              <FormatCurrency amount={rate.toString().replace('$', '')} />
              /hr
            </AgencyLabel>
          )}
        </Flex>
      </AgencyGridCardContentWrapper>

      <Flex
        alignItems="center"
        height="55px"
        minHeight="55px"
        maxHeight="44px"
        width="100%"
        minWidth="100%"
      >
        {type === 'Multiple' ? (
          <BKJCheckboxListItem
            label={t('common:SELECT')}
            value={agency.id}
            name={nameToUse}
            selected={selected}
            onChange={onChangeForm}
          />
        ) : (
          <BKJRadioInput
            label={t('common:SELECT')}
            name={nameToUse}
            value={`${agency.id}`}
            checked={selected.includes(agency.id)}
            onChange={onChangeForm}
          />
        )}
      </Flex>
    </AgencyGridCardWrapper>
  );
};
